module.exports = __webpack_public_path__ + "img/Pic_OnlC_Ks_c.6467a6cc.png";